import * as React from "react"
import styled from "styled-components"
import ProgressiveImage from "react-progressive-bg-image"
import { FetchSingleListingPictures } from "../../generated/graphql"
import Gallery from "../../components/gallery"
import Box from "../../components/box"
import Colors from "../../theme/colors"
import { DEFAULT_SPACE_PICTURE } from "src/config/constants"

const ImagesWrapper = styled(Box as any)`
  position: relative;
  height: 600px;
  width: 100%;
`

const ViewPhotosButton = styled.button`
  position: absolute;
  top: 24px;
  right: 24px;
  cursor: pointer;
  width: 107px;
  height: 32px;
  color: ${Colors.darkGrey};
  font-size: 14px;
  font-weight: 600;
  border-radius: 16px;
  box-shadow: 0 2px 10px 0 rgba(0, 0, 0, 0.2);
  border: solid 2px rgba(51, 51, 51, 0.2);
  background-color: #ffffff;
  z-index: 3;
`

const FirstProgressiveImage = styled(ProgressiveImage)`
  background-size: cover;
  background-position: center;
  width: 100%;
  flex: 4 2 900px;
  cursor: pointer;
`

const SecondProgressiveImage = styled(ProgressiveImage)`
  background-size: cover;
  background-position: center;
  width: 100%;
  flex: 1 1 382px;
  cursor: pointer;
  @media (max-width: 600px) {
    display: none;
  }
`

interface Props {
  pictures?: Array<FetchSingleListingPictures> | null
}

interface State {
  showGallery: boolean
}

class SingleListingGallerySection extends React.PureComponent<Props, State> {
  state: State = {
    showGallery: false
  }
  handleGalleryClick = () => this.setState({ showGallery: true })
  render() {
    const { pictures } = this.props
    return (
      <React.Fragment>
        <Gallery
          visible={this.state.showGallery}
          images={pictures && pictures.length > 0 ? pictures : [{ url: DEFAULT_SPACE_PICTURE }]}
          onClose={() => this.setState({ showGallery: false })}
        />
        <ImagesWrapper>
          <ViewPhotosButton onClick={this.handleGalleryClick}>View Photos</ViewPhotosButton>
          <FirstProgressiveImage
            src={pictures && pictures[0] ? pictures[0].url : DEFAULT_SPACE_PICTURE}
            alt="gallery image"
            placeholder={pictures && pictures[0] ? pictures[0].url : DEFAULT_SPACE_PICTURE}
            onClick={this.handleGalleryClick}
            transition="all 1s linear"
          />
          <SecondProgressiveImage
            src={pictures && pictures[1] ? pictures[1].url : DEFAULT_SPACE_PICTURE}
            alt="gallery image"
            placeholder={pictures && pictures[1] ? pictures[1].url : DEFAULT_SPACE_PICTURE}
            onClick={this.handleGalleryClick}
            transition="all 1s linear"
          />
        </ImagesWrapper>
      </React.Fragment>
    )
  }
}

export default SingleListingGallerySection
